import PostInicio from "../../pages/postInicio/PostInicio"
// import Sidebar from "../../components/sidebar/Sidebar"
import "./inicio.css"


export default function Inicio() {
    return (
        <>
        <div className="inicio">
            <div className="postInicio">
                <PostInicio />
            </div>

            {/* <div className="sidebar">
                <Sidebar />
            </div> */}
                   
        </div>
        </>
    ); 
}